import { FormType } from '../../../form-types';
import type { GenericLabResultsQuestionAnswerFields } from './question';

export const genericLab: FormType<GenericLabResultsQuestionAnswerFields> = {
  name: 'Lab results',
  questions: ['genericBloodTest_labResults']
};
